<template>
  <div class="market-welfareOrderList-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch" >
      <el-button slot="btn" @click="onExport" :loading="exportLoading">导出</el-button>
    </Search>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #name="{ row }">{{ row.name || '---' }}</template>
      <template #productType="{ row }">{{ row.productType ? formatAll(row.productType) : '---' }}</template>
      <template #phone="{ row, scope }">
        <span :key="tableKey">{{ row.phone_show || row.phone }}</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.phone" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index)">
            {{ row.phone_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
      <template #channelName="{ row }">{{ row.channelName || '---' }}</template>
      <template #expireTime="{ row }">{{ row.expireTime ? $moment(row.expireTime).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #paymentOrderId="{ row }">{{ row.paymentOrderId || '---' }}</template>
      <template #payTime="{ row }">{{ row.payTime ? $moment(row.payTime).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #source="{ row }">{{ row.source ? row.source : '---' }}</template>
      <template #orderStatus="{ row }">{{ row.orderStatus ? formatAll(row.orderStatus) : '---' }}</template>
      <template #mallName="{ row }">{{ row.mallName ? row.mallName : '---' }}</template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import { api_postMarketWelfareOrderPage, api_postWelfareOrderExport } from '@/api/market'
import { api_getUserPhone } from '@/api/common'
import { downFile } from "@/utils";
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import aes from '@/common/aes.js'
export default {
  name: "marketWelfareOrderListIndex",
  mixins: [ tableList ],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    const startDate = this.$moment().subtract(30, 'days').valueOf() //默认开始时间
    const endDate = this.$moment().subtract(0, 'days').valueOf() //默认结束时间
    console.log(startDate, endDate)
    return {
      renderData: [
        {
          label: "支付时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "payTime",
          valueFormat: 'timestamp',
        },
        {
          label: "商品名称",
          placeholder: "请输入商品名称",
          type: "input",
          key: "name",
        },
        {
          label: "会员手机号",
          placeholder: "请输入会员手机号",
          type: "input",
          key: "phone",
          maxLength: 11,
        },
        {
          label: "状态",
          placeholder: "请选择状态",
          type: "select",
          multiple: false,
          key: "status",
          option: [
            {
              value: "PaymentSuccess",
              label: "已付款",
            },
            {
              value: "Doing",
              label: "待付款",
            },
            {
              value: "Canceled",
              label: "已取消",
            },
            {
              value: "Refund",
              label: "已退款",
            },
          ],
        },
        {
          label: "类型",
          placeholder: "请选择类型",
          type: "select",
          multiple: false,
          key: "productType",
          option: [
            {
              value: "WelfareCoupon",
              label: "福利券",
            },
            {
              value: "Recharge",
              label: "直充商品",
            },
          ],
        },
      ],

      form: {
        payTime:[startDate,endDate]
      },
      tableThData: [
        { prop: "name", label: "商品名称", minWidth: "180", },
        { prop: "productType", label: "类型", minWidth: "120", },
        { prop: "phone", label: "会员手机号", minWidth: "160", },
        { prop: "channelName", label: "供应商", minWidth: "120", },
        { prop: "expireTime", label: "有效期", minWidth: "160", },
        { prop: "paymentOrderId", label: "交易订单号", minWidth: "150", },
        { prop: "payTime", label: "支付时间", minWidth: "160", },
        { prop: "mallName", label: "购买来源", minWidth: "100", },
        { prop: "orderStatus", label: "状态", minWidth: "100", },
        { prop: "source", label: "来源", minWidth: "120", },
      ],
      exportLoading: false,
      tableKey: false,
    };
  },
  created () {
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      let newParams = {...params}
      if(newParams.payTime && newParams.payTime.length > 0){
        newParams.payTimeFrom = newParams.payTime[0]*1
        newParams.payTimeTo = newParams.payTime[1]*1
      }
      delete newParams.payTime
      const data = await api_postMarketWelfareOrderPage(newParams)
      console.log('data: ', data);
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },
    // 导出
    async onExport() {
      this.exportLoading = true
      let params = {
        ...this.form,
      }
      params = {
        ...params,
        payTimeFrom: params.payTime && params.payTime[0] ? params.payTime[0]*1 : '',
        payTimeTo: params.payTime && params.payTime[1] ? params.payTime[1]*1 : '',
      }
      params.payTimeFrom ? '' : delete params.payTimeFrom
      params.payTimeTo ? '' : delete params.payTimeTo
      if(!params.payTimeFrom && !params.payTimeTo){
        this.$baseMessage('支付时间筛选不能为空', 'error')
      }else{
        delete params.payTime
        delete params.limit
        delete params.offset
        let res = await api_postWelfareOrderExport(params)
        console.log(res)
        downFile(res)
      }
      this.exportLoading = false
    },
    formatAll (key) {
      let allObj = {PaymentSuccess: '已付款',Doing: '待付款', Canceled: '已取消', Refund: '已退款',WelfareCoupon: '福利券',Recharge: '直充商品'}
      return allObj[key]
    },
    // 点击查看手机号
    async onLookPhone(row, index) {
      try {
        if (row.phone_show) {
          delete this.tableTrData[index].phone_show
        } else {
          const {phone} = await api_getUserPhone({id: row.userId})
          this.tableTrData[index].phone_show = aes.decrypt(phone)
        }
        this.tableKey = !this.tableKey
      } catch (error) {}
    },
  },
  watch: {},
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-welfareOrderList-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .remark-box {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    overflow: auto;

    &::v-deep img {
      width: 100% !important;
    }
  }

  .fun-btn-box {
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;
    .down-btn {
      padding: 0 10px;
    }
  }

  .copy {
    color: #05C8AF;
  }

  .del {
    color: #F74A4A;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }
  .dot-success{
    background: #05c8af;
  }

  .dot-clear {
    background: #F74A4A;
  }

  .dot-ing {
    background: #3775FF;
  }

  .dot-new {
    background: #ccc;
  }
}
</style>
